import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { ManagementServicesState } from './types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: ManagementServicesState = {
    managementServices: [],
    managementServicesItem: undefined
};


export const managementServices: Module<ManagementServicesState,RootState> = {
    state,
    getters,
    actions,
    mutations
};
